import React from 'react';
import { useCTAL } from './CTAL_Hooks.js';

export default function UserPublicTeamListItem({team, age_ms}) 
{
    const { team_id, setTeamID, setTeam, setTeamMemberRole, setShortTermGoal, setActionItemListDisplay, setTeamDisplayRefresh, num_display_columns, setTeamMembersList, setMainColumnDisplayType } = useCTAL();

    const show_main_display = (new_team_id) => { 
        if (new_team_id != team_id) {
            setTeamID(new_team_id); 
            setTeam(undefined);
            setShortTermGoal(undefined);
            setTeamMemberRole("");
            setTeamMembersList([]); //need to clear Team Member List so that Assign User does not display in ActionItemForm for Short/Long List
            setActionItemListDisplay("team-display");    
            if (num_display_columns < 3)
                setMainColumnDisplayType("Team"); 
        }
        else
            setTeamDisplayRefresh(true); 
    }

    return (
        <>
            <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-start" onClick={ () => show_main_display(team.TeamID) } >
                <div class="ms-2 me-auto">
                    <div class="fw-bold">{team.TeamName} {age_ms}</div>
                    <small><i>{team.TeamDescription}</i></small>
                </div>
            </li>
        </>
    );
}
